<template>
    <div class="relative dark flex flex-col min-h-screen">
        <div class="window-drag-zone fixed top-0 inset-x-0 h-7"></div>

        <div class="flex flex-grow items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
            <div class="bg-gradient-to-br from-gray-800 via-gray-900 to-gray-950 ring-1 ring-white/10 p-14 max-w-xl w-full rounded-xl shadow-md shadow-gray-950">
                <img class="size-[72px]" src="@/assets/img/logo.png" />
                <slot />
            </div>
        </div>
        <div class="flex flex-shrink-0 items-center justify-center p-4">
            <a href="https://samuliban.com" target="_blank" class="text-xs text-gray-500 hover:text-gray-900 transition-colors">
                &copy; SAMU Liban {{ (new Date).getFullYear() }}
            </a>
        </div>
    </div>
</template>
